import { all, call } from 'redux-saga/effects';
import { onListJobsStart } from './list-jobs/saga';

export default function* onJobsAction() {
  yield all([call(onListJobsStart)]);
}
